import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {NgForOf} from "@angular/common";
import {TemplateService} from "../../../_services/template.service";
import {Router} from "@angular/router";
import {Fitrite365Template} from "../../../_models/Fitrite365Template";

@Component({
  standalone: true,
  templateUrl: './select-bespoke-template.html',
  imports: [
    NgForOf
  ],
  encapsulation: ViewEncapsulation.None
})

export class SelectBespokeTemplateComponent implements OnInit{

  constructor(private templateService: TemplateService, private router: Router) {
  }

  public templates: Fitrite365Template[] = [];
  ngOnInit() {
    this.getTemplates();
  }

  getTemplates() {
    this.templateService.searchBespokeTemplates(100000031)
      .subscribe(templates => {
        this.templates = templates;
      })
  }

  createQuote(templateId: string) {
    this.router.navigate(['/quotes/createbespoke/' + templateId]);
  }
}
